// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/FooterBlock/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SixthBlock_root__JtLfZ {
  position: relative;
  min-height: 100vh;
  font-size: clamp(12px, 1vw, 16px);
  color: #fff;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
  background-size: cover;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #00377c;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_overlay__PXBTo {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_overlay__PXBTo img {
  max-width: 100%;
  height: auto;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF {
  padding: 40px;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v {
  grid-area: 1/1/2/2;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(2) {
  grid-area: 1/2/2/3;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(3) {
  grid-area: 2/2/3/3;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(4) {
  grid-area: 1/3/2/4;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(5) {
  grid-area: 2/3/3/4;
}
.SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:last-child {
  grid-area: 1/4/2/5;
}

@media (max-width: 991px) {
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM {
    position: static;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v {
    grid-area: 1/1/4/2;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(2) {
    grid-area: 1/2/2/3;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(3) {
    grid-area: 2/2/3/3;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(4) {
    grid-area: 3/2/4/3;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(5) {
    grid-area: 1/3/2/4;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:nth-child(6) {
    grid-area: 2/3/3/4;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_infoBlock__TBH4v:last-child {
    grid-area: 3/3/4/4;
  }
}
@media (max-width: 768px) {
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF {
    display: flex;
    justify-content: center;
    padding: 20px;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_logoBlock__xzxcP img {
    width: 100px;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_socialsBlock__hRjQY img {
    width: 30px;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_flexBlock__MwN7c {
    flex-direction: column;
  }
}
@media (max-width: 500px) {
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C {
    display: flex;
    flex-direction: column;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_logoBlock__xzxcP img {
    width: 80px;
  }
  .SixthBlock_root__JtLfZ .SixthBlock_footer__4g0FM .SixthBlock_container__ooYTF .SixthBlock_gridBlock__CuV6C .SixthBlock_socialsBlock__hRjQY img {
    width: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainBlock/SixthBlock/SixthBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,WAAA;EACA,oEAAA;EAEA,sBAAA;AAAF;AAEE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,6BAAA;AAAN;AAEM;EACE,eAAA;EACA,YAAA;AAAR;AAII;EACE,aAAA;AAFN;AAIM;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;AAFR;AAIQ;EACE,kBAAA;AAFV;AAIU;EACE,kBAAA;AAFZ;AAKU;EACE,kBAAA;AAHZ;AAMU;EACE,kBAAA;AAJZ;AAOU;EACE,kBAAA;AALZ;AAQU;EACE,kBAAA;AANZ;;AAcA;EAEI;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,iBAAA;EAZJ;EAeM;IACE,aAAA;IACA,qCAAA;IACA,kCAAA;EAbR;EAeQ;IACE,kBAAA;EAbV;EAeU;IACE,kBAAA;EAbZ;EAgBU;IACE,kBAAA;EAdZ;EAiBU;IACE,kBAAA;EAfZ;EAkBU;IACE,kBAAA;EAhBZ;EAmBU;IACE,kBAAA;EAjBZ;EAoBU;IACE,kBAAA;EAlBZ;AACF;AA0BA;EAGM;IACE,aAAA;IACA,uBAAA;IACA,aAAA;EA1BN;EA4BM;IACE,qBAAA;IACA,kBAAA;EA1BR;EA6BU;IACE,YAAA;EA3BZ;EAiCQ;IACE,WAAA;EA/BV;EAmCM;IACE,sBAAA;EAjCR;AACF;AAuCA;EAIQ;IACE,aAAA;IACA,sBAAA;EAxCR;EA2CU;IACE,WAAA;EAzCZ;EA8CU;IACE,WAAA;EA5CZ;AACF","sourcesContent":[".root {\n  position: relative;\n  min-height: 100vh;\n  font-size: clamp(12px, 1vw, 16px);\n  color: #fff;\n  background: url(\"../../../assets/img/FooterBlock/background.png\") center\n    no-repeat;\n  background-size: cover;\n\n  .footer {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background: #00377c;\n\n    .overlay {\n      position: absolute;\n      top: 50%;\n      right: 0;\n      transform: translate(0, -50%);\n\n      img {\n        max-width: 100%;\n        height: auto;\n      }\n    }\n\n    .container {\n      padding: 40px;\n\n      .gridBlock {\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        grid-template-rows: repeat(2, 1fr);\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n\n        .infoBlock {\n          grid-area: 1 / 1 / 2 / 2;\n\n          &:nth-child(2) {\n            grid-area: 1 / 2 / 2 / 3;\n          }\n\n          &:nth-child(3) {\n            grid-area: 2 / 2 / 3 / 3;\n          }\n\n          &:nth-child(4) {\n            grid-area: 1 / 3 / 2 / 4;\n          }\n\n          &:nth-child(5) {\n            grid-area: 2 / 3 / 3 / 4;\n          }\n\n          &:last-child {\n            grid-area: 1 / 4 / 2 / 5;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    .footer {\n      position: static;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-height: 100vh;\n\n      .container {\n        .gridBlock {\n          display: grid;\n          grid-template-columns: repeat(3, 1fr);\n          grid-template-rows: repeat(3, 1fr);\n\n          .infoBlock {\n            grid-area: 1 / 1 / 4 / 2;\n\n            &:nth-child(2) {\n              grid-area: 1 / 2 / 2 / 3;\n            }\n\n            &:nth-child(3) {\n              grid-area: 2 / 2 / 3 / 3;\n            }\n\n            &:nth-child(4) {\n              grid-area: 3 / 2 / 4 / 3;\n            }\n\n            &:nth-child(5) {\n              grid-area: 1 / 3 / 2 / 4;\n            }\n\n            &:nth-child(6) {\n              grid-area: 2 / 3 / 3 / 4;\n            }\n\n            &:last-child {\n              grid-area: 3 / 3 / 4 / 4;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    .footer {\n      .container {\n        display: flex;\n        justify-content: center;\n        padding: 20px;\n\n        .gridBlock {\n          grid-column-gap: 10px;\n          grid-row-gap: 10px;\n\n          .logoBlock {\n            img {\n              width: 100px;\n            }\n          }\n        }\n\n        .socialsBlock {\n          img {\n            width: 30px;\n          }\n        }\n\n        .flexBlock {\n          flex-direction: column;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .footer {\n      .container {\n        .gridBlock {\n          display: flex;\n          flex-direction: column;\n\n          .logoBlock {\n            img {\n              width: 80px;\n            }\n          }\n\n          .socialsBlock {\n            img {\n              width: 25px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SixthBlock_root__JtLfZ`,
	"footer": `SixthBlock_footer__4g0FM`,
	"overlay": `SixthBlock_overlay__PXBTo`,
	"container": `SixthBlock_container__ooYTF`,
	"gridBlock": `SixthBlock_gridBlock__CuV6C`,
	"infoBlock": `SixthBlock_infoBlock__TBH4v`,
	"logoBlock": `SixthBlock_logoBlock__xzxcP`,
	"socialsBlock": `SixthBlock_socialsBlock__hRjQY`,
	"flexBlock": `SixthBlock_flexBlock__MwN7c`
};
export default ___CSS_LOADER_EXPORT___;
